export default __webpack_public_path__ + "feature43b6b4c.png";